import { useMutation } from '@apollo/client';
import { Button, useFlashMessage } from '@indigo-ag/component-module';
import { AgFinancingInput, AgFinancingPhaseStatus } from '@indigo-ag/schema';
import React, { useContext, useState } from 'react';

import i18next from 'core/i18n';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { upsertFinancingAgFinancing } from 'features/brazil-grower/queries';
import { DecisionModal } from '../../../../../BrazilGrowerFinance/shared/DecisionModal/DecisionModal';

export const EscalateToManagerButton: React.FunctionComponent = () => {
  /**
   * Context
   */
  const { agFinance } = useContext(FinanceProcessContext);
  /**
   * State
   */
  const [isDecisionSecondaryOpen, setIsDecisionSecondaryOpen] = useState(false);

  /**
   * Mutations
   */
  const [upsertFinancingAgFinancingFn] = useMutation(upsertFinancingAgFinancing);
  const updateManagerApproval = async (notes: string) => {
    const newAgFinancingData: Partial<AgFinancingInput> = {
      id: agFinance?.id,
      phase1: {
        status: AgFinancingPhaseStatus.AWAITING_MANAGER_APPROVAL,
        notes
      }
    };

    try {
      await upsertFinancingAgFinancingFn({
        variables: {
          data: newAgFinancingData
        }
      });
      addFlashMessage({
        content: `${i18next.t('sent')}`,
        title: '',
        variant: 'success'
      });
    } catch {
      addFlashMessage({
        content: i18next.t('error'),
        title: '',
        variant: 'error'
      });
    }
  };

  const { addFlashMessage } = useFlashMessage();

  const confirmSecondaryDecision = async (notes: string) => {
    return await updateManagerApproval(notes);
  };

  const closeSecondaryDecisionModal = () => {
    setIsDecisionSecondaryOpen(false);
  };

  const takeSecondaryDecision = () => {
    setIsDecisionSecondaryOpen(true);
  };

  return (
    <>
      <Button variant="tertiary" onClick={takeSecondaryDecision} size="small">
        {i18next.t('escalateToManager')}
      </Button>
      <DecisionModal
        open={isDecisionSecondaryOpen}
        title={i18next.t('escalateToManager')}
        message={i18next.t('phase1ManagerApprovalReview')}
        closeModal={closeSecondaryDecisionModal}
        onConfirmAction={confirmSecondaryDecision}
        notesRequired={true}
      />
    </>
  );
};
